var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "buying-guide" } },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            { staticClass: "mb-3", attrs: { "align-v": "center" } },
            [
              _c("b-col", { attrs: { cols: "12", lg: "" } }, [
                _c("h1", [_vm._v("Guide to Buying the Perfect Picture Mount")]),
                _c("p", { staticClass: "lead" }, [
                  _vm._v(
                    "Below is a step-by-step guide to buying the perfect picture mount for your artwork or photograph. It will guide you from making sure the size you are buying is correct for your item, through to picking the perfect colour to make your artwork stand out."
                  ),
                ]),
              ]),
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c("b-card", [
                    _c("h4", { staticClass: "card-title" }, [
                      _vm._v("Contents"),
                    ]),
                    _c("ul", [
                      _c("li", [
                        _c("a", { attrs: { href: "#measure" } }, [
                          _vm._v("How to measure your picture mount"),
                        ]),
                      ]),
                      _c("li", [
                        _c("a", { attrs: { href: "#colour" } }, [
                          _vm._v("Choose the colour of your picture mount"),
                        ]),
                      ]),
                      _c("li", [
                        _c("a", { attrs: { href: "#quality" } }, [
                          _vm._v("Choose the quality of your picture mount"),
                        ]),
                      ]),
                      _c("li", [
                        _c("a", { attrs: { href: "#multi-aperture" } }, [
                          _vm._v("Multi-aperture Photo Mounts"),
                        ]),
                      ]),
                      _c("li", [
                        _c("a", { attrs: { href: "#multi-layered" } }, [
                          _vm._v("Multi-layered Picture Mounts"),
                        ]),
                      ]),
                      _c("li", [
                        _c("a", { attrs: { href: "#undermount" } }, [
                          _vm._v("What is an Undermount?"),
                        ]),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-container",
        {
          staticClass: "bg-light py-5 px-0",
          attrs: { fluid: "", id: "measure" },
        },
        [
          _c(
            "b-container",
            [
              _c("h2", [_vm._v("How to measure for your picture mount")]),
              _c("p", [
                _vm._v(
                  "When measuring for a piece of art or a photo to be fitted behind a mount, you need to decide how much of the piece you would like to see. As well as being decorative, the bespoke mount holds the artwork in place so we allow for 3mm of overlap on each side."
                ),
              ]),
              _c("p", [
                _vm._v(
                  "So, for example, if your photo measures 200x300mm, we would cut the mount aperture to measure 194x294mm. So 6mm off the size in total."
                ),
              ]),
              _c("p", [
                _vm._v(
                  'The width of the mount is down to personal taste. While wide mounts for smaller photos are very on trend at the moment, you may want to choose a thinner one to ensure it isn\'t "lost" in the frame.'
                ),
              ]),
              _c(
                "b-row",
                {
                  staticClass: "mt-5",
                  attrs: { "align-h": "center", "align-v": "center" },
                },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-3 mb-md-0",
                      attrs: { md: "6", lg: "4", xl: "3" },
                    },
                    [
                      _c(
                        "picture",
                        [
                          _c("source", {
                            attrs: {
                              srcset: _vm.measuringImgWebp,
                              type: "image/webp",
                            },
                          }),
                          _c("source", {
                            attrs: {
                              srcset: _vm.measuringImg,
                              type: "image/jpeg",
                            },
                          }),
                          _c("b-img", {
                            attrs: {
                              src: _vm.measuringImg,
                              alt: "Measuring your mount size using an existing frame",
                              fluid: "",
                              rounded: "",
                              thumbnail: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6", lg: "4", xl: "3", "offset-lg": "2" } },
                    [
                      _c(
                        "picture",
                        [
                          _c("source", {
                            attrs: {
                              srcset: _vm.measuringCloseupImgWebp,
                              type: "image/webp",
                            },
                          }),
                          _c("source", {
                            attrs: {
                              srcset: _vm.measuringCloseupImg,
                              type: "image/jpeg",
                            },
                          }),
                          _c("b-img", {
                            attrs: {
                              src: _vm.measuringCloseupImg,
                              alt: "How to measure a mount for a picture frame",
                              fluid: "",
                              rounded: "",
                              thumbnail: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-container", { staticClass: "py-5", attrs: { id: "colour" } }, [
        _c("h2", [_vm._v("Choose the colour of your picture mount")]),
        _c("p", [
          _vm._v(
            "The mount colour is a very important decision when choosing a frame for your artwork. It sits between your artwork and the frame, so needs to compliment both without standing out too much."
          ),
        ]),
        _c("p", [
          _vm._v(
            "Snow White and Minuet are our two most popular colours as these can be put with almost any piece of artwork or photograph."
          ),
        ]),
        _c("p", [
          _vm._v(
            "There are many options when it comes to colour, so you need to look at all of the colours in your piece of art and decide which part of it you'd like to pick out."
          ),
        ]),
        _c("p", { staticClass: "mb-0" }, [
          _vm._v(
            "It is important that the mount you choose will not overshadow the artwork. So, if you choose a dark green mount for a delicate watercolour, this might avert the attention from the artwork.\nIf you would like to pick out a colour but not have it for the full width, you might consider a double or even triple mount.  "
          ),
        ]),
      ]),
      _c(
        "b-container",
        {
          staticClass: "bg-light py-5 px-0",
          attrs: { fluid: "", id: "quality" },
        },
        [
          _c("b-container", [
            _c("h2", [_vm._v("Choose the quality of your picture mount")]),
            _c("p", [
              _vm._v(
                "All our picture mounts are rated level 3 or better on the Fine Art Trade Guild Mountboard Quality Standards Scale. This scale ranges from Level 1 for the highest quality museum mounts to Level 4 for commercial low-quality mounts."
              ),
            ]),
            _c("p", [
              _vm._v(
                "If you want a top quality mount that will not cause any adverse effects to your artwork even after many years of contact, you should look at the Museum mounts, which are Level 1 Cotton Rag board with no paper fibres or lignin present.These have been rigorously tested to be free of any chemicals, acids or alkalies that could affect your artworks.\nThe complete specification of our museum grade mountboards is shown below:"
              ),
            ]),
            _c("ul", { staticClass: "mb-0" }, [
              _c("li", [_vm._v("100% cotton fibre.")]),
              _c("li", [_vm._v("Free from lignin and sulphur.")]),
              _c("li", [_vm._v("OBA-free (Optical Brightening Agents).")]),
              _c("li", [
                _vm._v("Lightfast, Blue Wool Scale reading of 5 minimum."),
              ]),
              _c("li", [
                _vm._v(
                  "Passes the Silver Tarnish Test and Photographic Activity Test."
                ),
              ]),
              _c("li", [
                _vm._v(
                  "EVA polymer adhesive, contains no plasticisers, pH7.0."
                ),
              ]),
              _c("li", [
                _vm._v("Museum Cream: Buffered with calcium carbonate"),
              ]),
              _c("li", [_vm._v("TG Off White: unbuffered")]),
              _c("li", [
                _vm._v("Surface sized (pure non-ionic farina starch)."),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "b-container",
        { staticClass: "py-5", attrs: { id: "multi-aperture" } },
        [
          _c("h2", [_vm._v("Multi-aperture Photo Mounts")]),
          _c("p", [
            _vm._v(
              "Framing multiple photos in one frame is easily achievable with multiple aperture mounts. We can cut (within reason) any shape and quantity of window into a mount for you.\nSo, if you have a collection of photos that you'd like framing together, we will cut a bespoke mount using your measurements."
            ),
          ]),
          _c("p", [
            _vm._v(
              "This also works if you wanted to add a window underneath an object, such as a football shirt with a plaque below."
            ),
          ]),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v(
              "We have software which allows us to perfectly balance a multi-aperture mount so all borders can be equal and spaced properly."
            ),
          ]),
          _c(
            "b-row",
            {
              staticClass: "mt-5",
              attrs: { "align-h": "center", "align-v": "center" },
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "mb-3 mb-lg-0",
                  attrs: { md: "6", lg: "4", xl: "3" },
                },
                [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: _vm.multiApExampleOneImgWebp,
                          type: "image/webp",
                        },
                      }),
                      _c("source", {
                        attrs: {
                          srcset: _vm.multiApExampleOneImg,
                          type: "image/jpeg",
                        },
                      }),
                      _c("b-img", {
                        attrs: {
                          src: _vm.multiApExampleOneImg,
                          alt: "Basic multi-aperture picture & photo mounts",
                          fluid: "",
                          rounded: "",
                          thumbnail: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "b-col",
                {
                  staticClass: "mb-3 mb-lg-0",
                  attrs: { md: "6", lg: "4", xl: "3", "offset-xl": "1" },
                },
                [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: _vm.multiApExampleTwoImgWebp,
                          type: "image/webp",
                        },
                      }),
                      _c("source", {
                        attrs: {
                          srcset: _vm.multiApExampleTwoImg,
                          type: "image/jpeg",
                        },
                      }),
                      _c("b-img", {
                        attrs: {
                          src: _vm.multiApExampleTwoImg,
                          alt: "Multi-aperture picture mounts with a circle and rectangle apertures.",
                          fluid: "",
                          rounded: "",
                          thumbnail: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "b-col",
                { attrs: { md: "6", lg: "4", xl: "3", "offset-xl": "1" } },
                [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: _vm.multiApExampleThreeImgWebp,
                          type: "image/webp",
                        },
                      }),
                      _c("source", {
                        attrs: {
                          srcset: _vm.multiApExampleThreeImg,
                          type: "image/jpeg",
                        },
                      }),
                      _c("b-img", {
                        attrs: {
                          src: _vm.multiApExampleThreeImg,
                          alt: "Example of frame coins with a multi-aperture picture mount.",
                          fluid: "",
                          rounded: "",
                          thumbnail: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-container",
        {
          staticClass: "bg-light py-5 px-0",
          attrs: { fluid: "", id: "multi-layered" },
        },
        [
          _c(
            "b-container",
            [
              _c("h2", [_vm._v("Multi-layered Picture Mounts")]),
              _c("p", [
                _vm._v(
                  "Multiple layer mounts are a great way to enhance your artwork or photo. It allows you to have more than one colour showing if desired, or just a simple two layered white mount can change the look of a frame completely."
                ),
              ]),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "This option of mount is very popular with artists as it adds a touch of elegance and professionalism to a frame."
                ),
              ]),
              _c(
                "b-row",
                {
                  staticClass: "mt-5",
                  attrs: { "align-h": "center", "align-v": "center" },
                },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-3 mb-lg-0",
                      attrs: { md: "6", lg: "4", xl: "3" },
                    },
                    [
                      _c(
                        "picture",
                        [
                          _c("source", {
                            attrs: {
                              srcset: _vm.doubleMountExampleOneImgWebp,
                              type: "image/webp",
                            },
                          }),
                          _c("source", {
                            attrs: {
                              srcset: _vm.doubleMountExampleOneImg,
                              type: "image/jpeg",
                            },
                          }),
                          _c("b-img", {
                            attrs: {
                              src: _vm.doubleMountExampleOneImg,
                              alt: "Example of layered picture mounts with white and grey.",
                              fluid: "",
                              rounded: "",
                              thumbnail: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "mb-3 mb-lg-0",
                      attrs: { md: "6", lg: "4", xl: "3", "offset-xl": "1" },
                    },
                    [
                      _c(
                        "picture",
                        [
                          _c("source", {
                            attrs: {
                              srcset: _vm.doubleMountExampleThreeImgWebp,
                              type: "image/webp",
                            },
                          }),
                          _c("source", {
                            attrs: {
                              srcset: _vm.doubleMountExampleThreeImg,
                              type: "image/jpeg",
                            },
                          }),
                          _c("b-img", {
                            attrs: {
                              src: _vm.doubleMountExampleThreeImg,
                              alt: "Double picture mount example within a frame.",
                              fluid: "",
                              rounded: "",
                              thumbnail: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "6", lg: "4", xl: "3", "offset-xl": "1" } },
                    [
                      _c(
                        "picture",
                        [
                          _c("source", {
                            attrs: {
                              srcset: _vm.doubleMountExampleTwoImgWebp,
                              type: "image/webp",
                            },
                          }),
                          _c("source", {
                            attrs: {
                              srcset: _vm.doubleMountExampleTwoImg,
                              type: "image/jpeg",
                            },
                          }),
                          _c("b-img", {
                            attrs: {
                              src: _vm.doubleMountExampleTwoImg,
                              alt: "Layered picture frame mounts to make artwork stand out.",
                              fluid: "",
                              rounded: "",
                              thumbnail: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-container",
        { staticClass: "py-5", attrs: { id: "mountslips" } },
        [
          _c("h2", [_vm._v("Mountslips")]),
          _c("p", [
            _vm._v(
              "Mount slips can be added to a mount as another layer of decoration. They are a great way to embellish a mount with a thin line of wooden moulding sitting within the aperture."
            ),
          ]),
          _c("p", [
            _vm._v(
              "Mount slips can be used on traditional watercolours or more modern prints, depending on the overall look you are aiming for."
            ),
          ]),
          _c("p", { staticClass: "mb-0" }, [
            _vm._v(
              "Barefaced slips can be used if you prefer to paint them to match an exact colour in your artwork."
            ),
          ]),
          _c(
            "b-row",
            {
              staticClass: "mt-5",
              attrs: { "align-h": "center", "align-v": "center" },
            },
            [
              _c(
                "b-col",
                {
                  staticClass: "mb-3 mb-md-0",
                  attrs: { md: "6", lg: "4", xl: "3" },
                },
                [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: _vm.mountslipExampleOneImgWebp,
                          type: "image/webp",
                        },
                      }),
                      _c("source", {
                        attrs: {
                          srcset: _vm.mountslipExampleOneImg,
                          type: "image/jpeg",
                        },
                      }),
                      _c("b-img", {
                        attrs: {
                          src: _vm.mountslipExampleOneImg,
                          alt: "Example of a mountslip used while framing an artwork.",
                          fluid: "",
                          rounded: "",
                          thumbnail: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "b-col",
                { attrs: { md: "6", lg: "4", xl: "3", "offset-lg": "2" } },
                [
                  _c(
                    "picture",
                    [
                      _c("source", {
                        attrs: {
                          srcset: _vm.mountslipExampleTwoImgWebp,
                          type: "image/webp",
                        },
                      }),
                      _c("source", {
                        attrs: {
                          srcset: _vm.mountslipExampleTwoImg,
                          type: "image/jpeg",
                        },
                      }),
                      _c("b-img", {
                        attrs: {
                          src: _vm.mountslipExampleTwoImg,
                          alt: "Gold mountslip around artwork to outline the artwork.",
                          fluid: "",
                          rounded: "",
                          thumbnail: "",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-container",
        {
          staticClass: "bg-light py-5 px-0",
          attrs: { fluid: "", id: "undermount" },
        },
        [
          _c("b-container", [
            _c("h2", [_vm._v("What is an Undermount?")]),
            _c("p", [
              _vm._v(
                "This mountboard is suitable for mounting your artwork onto. The purpose is to be used as a barrier between the artwork and the backing board, and prevents the transfer of damaging chemicals from non-certified backing boards onto artwork substrates."
              ),
            ]),
            _c("p", { staticClass: "mb-0" }, [
              _vm._v(
                "The undermount we sell is 1.4mm thick whitecore mountboard. One face of the undermount board is Snow White (#8001), and the other face is Minuet (#8627)."
              ),
            ]),
          ]),
        ],
        1
      ),
      _c("b-container", { staticClass: "py-5 text-center" }, [
        _c("h3", [_vm._v("Contact Us")]),
        _c("p", { staticClass: "text-center" }, [
          _vm._v(
            "Please contact us if you have any questions or enquiries using our details below:"
          ),
        ]),
        _c("p", { staticClass: "lead text-center" }, [
          _c("span", { staticClass: "material-icons mr-2 md" }, [
            _vm._v("phone"),
          ]),
          _c("a", { attrs: { href: "tel:01246554338" } }, [
            _vm._v("01246 554338"),
          ]),
        ]),
        _c("p", { staticClass: "lead text-center mb-0" }, [
          _c("span", { staticClass: "material-icons mr-2 md" }, [
            _vm._v("email"),
          ]),
          _c("a", { attrs: { href: "mailto:sales@epicturemounts.co.uk" } }, [
            _vm._v("sales@epicturemounts.co.uk"),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }